import React, { useEffect } from 'react';

const AdSenseAd = ({ slot }) => {
  useEffect(() => {
    if (navigator.userAgent === 'ReactSnap') return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error", e);
    }
  }, [slot]); // Rerun effect if slot changes (though unlikely for static ads)

  return (
    <div className="adsense-ad-container">
      <ins className="adsbygoogle"
           style={{ display: 'block' }}
           data-ad-client="ca-pub-9716618346297669"
           data-ad-slot={slot}
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </div>
  );
};

export default AdSenseAd;
